import React from 'react';

import './PageHeader.scss';

interface Props {
    title: string;
    subtitle?: string;
}

const PageHeader = ({ title, subtitle }: Props) => {
    return (
        <header className="page-header">
            <h1 className="page-header__title v2-text-heading">{title}</h1>
            {subtitle && <h2 className="page-header__subtitle v2-text-heading">{subtitle}</h2>}
        </header>
    );
};

export default PageHeader;
